import React, { createContext, useState, useEffect } from "react";
import { useQuery, gql } from "@apollo/client";

// Create Context
const GetCookLaterRecipeContext = createContext();

// Define the GraphQL query
const GET_SCHEDULE_COOKING = gql`
  query GetScheduleCooking($kitchen_id: ID!) {
    getScheduleCooking(kitchen_id: $kitchen_id)
  }
`;

export const GetCookLaterRecipeProvider = ({ children, kitchenId }) => {
  const { data, loading, error, refetch } = useQuery(GET_SCHEDULE_COOKING, {
    variables: { kitchen_id: kitchenId },
    skip: !kitchenId, // Skip the query if kitchenId is not provided
    pollInterval: 5000,
  });

  const [scheduleCooking, setScheduleCooking] = useState(null);

  useEffect(() => {
    if (data) {
      setScheduleCooking(data.getScheduleCooking); // Update the state when data is available
    }
  }, [data]);

  return (
    <GetCookLaterRecipeContext.Provider
      value={{ scheduleCooking, loading, error, refetch }}
    >
      {children}
    </GetCookLaterRecipeContext.Provider>
  );
};

// Hook to use the context
export const useGetCookLaterRecipe = () => {
  const context = React.useContext(GetCookLaterRecipeContext);
  if (context === undefined) {
    throw new Error(
      "useGetCookLaterRecipe must be used within a GetCookLaterRecipeProvider"
    );
  }
  return context;
};
